import React from 'react';
import styles from './ViewIncidentDetails.module.css';

const ViewIncidentDetails = () => {
  return (
    <div className={styles.viewPagerdutyContainer}>
      <p>
        ( View on{' '}
        <a
          data-testid={'serviceUrlLinkTestId'}
          className={styles.pagerDutyLink}
          href={process.env.REACT_APP_PAGERDUTY_SERVICE_URL}
          target="_blank"
          rel="noopener noreferrer">
          Paderduty
        </a>{' '}
        ){' '}
      </p>
    </div>
  );
};

export default ViewIncidentDetails;
